<button mat-raised-button
        type="submit"
        color="accent"
        [disabled]="disabled || loading"
        (click)="submit.emit()">
  <span [ngClass]="loading ? (theme == 'light' ? 'loading-light' : 'loading-dark') : ''">
    <mat-spinner [color]="(theme == 'light' ? 'primary' : 'accent')" diameter="15" *ngIf="loading"></mat-spinner>
    <ng-content></ng-content>
  </span>
</button>
